export default __webpack_public_path__ + "static/media/stargrills_3.97136c1e.jpg";